export interface Invoice {
  id: number;
  invoiceDocId?: string; // Firebase document ID (added for payment)
  requestId?: string; // Added for payment handling
  requestNumber: string;
  service: string;
  serviceKey?: string;
  amount: number;
  currency: string;
  status: InvoiceStatus;
  dueDate: Date;
  createdDate: Date;
  description?: string;
  descriptionKey?: string;
  vendorId?: number;
  residentId?: number;
}

export enum InvoiceStatus {
  PAID = 'paid',
  UNPAID = 'unpaid',
  OVERDUE = 'overdue',
  CANCELLED = 'cancelled',
}
